<template>
  <div v-if="!larger" :class="['flex']" key="modal" @click="modalPosition()">
    <vue-resizable
      :class="['modal', windowName]"
      dragSelector=".topBar"
      :width="modalWidth"
      :height="modalHeight"
      :active="[]"
      ref="modalPos"
    >
      <div
        class="topBar"
        @dblclick="!nonResizables.includes(windowName) ? (larger = true) : null"
      >
        <span v-if="!secretName.includes(windowName)" class="padding">
          {{ windowName }}.html
        </span>
        <span v-else class="padding">Error</span>
        <span class="padding">
          <div
            v-if="!nonResizables.includes(windowName)"
            class="largerBtn"
            @click="larger = !larger"
          >
            ❒
          </div>
          <div class="closeBtn" @click="$emit('closed', '')">✕</div>
        </span>
      </div>
      <div class="modalContent">
        <div v-if="!secretName.includes(windowName)" class="langSelect">
          <span @click="$emit('english', false)" class="lang fr">FR</span>
          <span @click="$emit('english', true)" class="lang en">EN</span>
        </div>
        <transition name="modalTrans" mode="out-in">
          <component
            :is="windowName"
            :english="english"
            :larger="larger"
            :isMobile="isMobile"
            :easterEggData="easterEggData"
            @closed="$emit('closed', '')"
          />
        </transition>
      </div>
    </vue-resizable>
  </div>
  <div v-else class="modal largerModal" key="largerModal">
    <div>
      <div class="topBar" @dblclick="larger = false">
        <span class="padding">{{ windowName }}.html</span>
        <span class="padding">
          <div class="largerBtn" @click.exact="larger = !larger">❒</div>
          <div class="closeBtn" @click="$emit('closed', '')">✕</div>
        </span>
      </div>
      <div class="modalContent largerModalContent">
        <div class="langSelect">
          <span @click="$emit('english', false)" class="lang fr">FR</span>
          <span @click="$emit('english', true)" class="lang en">EN</span>
        </div>
        <component
          :is="windowName"
          :english="english"
          :larger="larger"
          :isMobile="isMobile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WhoAmI from "../infoComponents/WhoAmI";
import MapFromGeoIP from "../infoComponents/MapFromGeoIP";
import Settings from "../infoComponents/Settings";
import Welcome from "../infoComponents/Welcome";
import Capsule from "../infoComponents/Capsule";
import Artfolio from "../infoComponents/Artfolio";
import WiiMenu from "../infoComponents/WiiMenu";
import Lyruna from "../infoComponents/Lyruna";
import FramedBot from "../infoComponents/FramedBot";
import CleanMob from "../infoComponents/CleanMob";
import Funny404 from "../infoComponents/Funny404";
import EasterEgg from "../infoComponents/EasterEgg";

import VueResizable from "vue-resizable";

export default {
  name: "Modal",
  props: {
    windowName: String,
    isMobile: Boolean,
    english: Boolean,
    easterEggData: Object,
  },
  data: function () {
    return {
      larger: false,
      offsetTop: 0,
      nonResizables: ["WhoAmI", "Welcome", "EasterEgg"],
      secretName: ["EasterEgg"],
    };
  },
  computed: {
    modalWidth() {
      switch (this.windowName) {
        case "Welcome":
          return 400;
        case "WhoAmI":
          return 550;
        case "EasterEgg":
          return 450;

        default:
          return 960;
      }
    },
    modalHeight() {
      switch (this.windowName) {
        case "Welcome":
          return 590;
        case "WhoAmI":
          return 160;
        case "Capsule":
          return 690;
        case "MapFromGeoIP":
          return 650;
        case "Artfolio":
          return 730;
        case "FramedBot":
          return 730;
        case "CleanMob":
          return 730;
        case "EasterEgg":
          return 150;

        default:
          return 400;
      }
    },
  },
  methods: {
    modalPosition() {
      if (
        this.$refs.modalPos != undefined &&
        this.$refs.modalPos.$el.offsetTop <= 20 &&
        !this.nonResizables.includes(this.windowName)
      )
        this.larger = true;
    },
  },
  mounted: function () {
    this.larger = this.isMobile;
  },
  updated: function () {
    if (this.nonResizables.includes(this.windowName)) this.larger = false;
  },
  components: {
    Welcome,
    WhoAmI,
    Settings,
    Capsule,
    MapFromGeoIP,
    Artfolio,
    WiiMenu,
    Lyruna,
    FramedBot,
    CleanMob,
    Funny404,
    EasterEgg,
    VueResizable,
  },
};
</script>

<style >
/* Modal Itself CSS { */
.topBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 25px;
  color: rgb(238, 238, 238);
  background-color: var(--primary-light);
  transition: background-color 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.padding {
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.largerBtn {
  width: 50px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  user-select: text;
  -webkit-user-select: text;
}
.largerBtn:hover {
  background-color: rgba(255, 255, 255, 0.25);
}
.closeBtn {
  width: 50px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  user-select: text;
  -webkit-user-select: text;
}
.closeBtn:hover {
  background-color: red;
}
.modal {
  width: 50vw;
  height: 50vh;
  max-width: 100vw;
  position: absolute;
  margin: auto;
  z-index: 1;
  background-color: var(--background-color-light);
  backdrop-filter: blur(5px);
  cursor: auto;
  border-radius: 10px 10px 0 0;
  color: var(--font-color);
  -moz-box-shadow: 0px 0px 10px 0px #00000080;
  -webkit-box-shadow: 0px 0px 10px 0px #00000080;
  -o-box-shadow: 0px 0px 10px 0px #00000080;
  box-shadow: 0px 0px 10px 0px #00000080;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  transition: background-color 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    width 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    height 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.WhoAmI {
  width: 550px;
  height: 160px;
}
.WhoAmI .modalContent {
  height: 200px;
}
.Welcome {
  width: 400px;
  height: 590px;
}
.Welcome .modalContent {
  height: 550px;
}
.Capsule {
  width: 960px;
  height: 690px;
}
.Capsule .modalContent {
  height: 650px;
}
.MapFromGeoIP {
  width: 960px;
  height: 650px;
}
.MapFromGeoIP .modalContent {
  height: 610px;
}
.Artfolio,
.FramedBot,
.CleanMob {
  width: 960px;
  height: 730px;
}
.Artfolio .modalContent,
.FramedBot .modalContent,
.CleanMob .modalContent {
  height: 690px;
}
.WiiMenu,
.Lyruna {
  width: 960px;
  height: 400px;
}
.WiiMenu .modalContent,
.Lyruna .modalContent {
  height: 360px;
}
.EasterEgg {
  width: 400px;
  height: 150px;
}
.EasterEgg .modalContent {
  height: 110px;
}
.modalContent {
  margin: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-color: var(--primary-focus) #00000000;
  scrollbar-width: thin;
}
.largerModalContent {
  height: calc(100vh - 85px);
}
.largerModal {
  width: 100vw;
  height: calc(100vh - 40px);
  border-radius: 0;
  top: 0;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.modalTrans-enter-active {
  animation: modalTransIn 0.3s;
}
.modalTrans-leave-active {
  animation: modalTransOut 0.3s;
}

@keyframes modalTransIn {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  10% {
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes modalTransOut {
  80% {
    opacity: 0;
  }
  100% {
    transform: translateY(-50px);
    opacity: 0;
  }
}
/* } */
/* Modal Content CSS { */
h1 {
  margin-top: 5px !important;
  font-size: 2.75em;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  line-height: 1.5;
  margin: 0 0 0.5em 0;
}
a,
.lastname {
  color: var(--primary-focus);
  border-bottom: dotted 1px var(--primary-focus);
  text-decoration: none;
  background: radial-gradient(circle, var(--primary), var(--primary-hover));
  background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 150% 150%;
  font-weight: 700;
  animation: gradientAnim 5s ease infinite;
  transition: color 0.2s ease, border-bottom-color 0.2s ease;
}
.lastnameNoBorder {
  border-bottom: transparent;
}
a:hover,
.lastname:hover {
  border-bottom-color: transparent;
  color: var(--primary-hover);
  animation-direction: reverse;
  animation-duration: 1s;
}
.langSelect {
  position: absolute;
  right: 25px;
}
.lang {
  display: inline-flex;
  width: 35px;
  height: 27px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-dark);
  cursor: pointer;
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.lang:hover {
  background-color: var(--primary-hover);
}
.en {
  border-left: 3px solid var(--background-color-light);
  border-radius: 0 10px 10px 0;
}
.fr {
  border-radius: 10px 0 0 10px;
}
.wrapper > .inner {
  margin: 0 auto;
  padding-top: 2em;
  max-width: 100%;
  width: 75%;
}
h1.major {
  margin: 0 0 0.7em 0;
  position: relative;
  padding-bottom: 0.35em;
  font-size: 2.5em;
}

h1.major::after {
  background-image: linear-gradient(
    to right,
    var(--primary),
    var(--primary-hover)
  );
  border-radius: 0.2em;
  bottom: 0;
  content: "";
  height: 0.05em;
  position: absolute;
  right: 0;
  width: 100%;
}

.FramedBot .modalContent img {
  width: 100%;
}

@keyframes gradientAnim {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.langTrans-enter-active {
  animation: langTransIn 0.5s;
}
@keyframes langTransIn {
  0% {
    transform: translateX(200px);
    opacity: 0;
  }
  10% {
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
/* } */
</style>
